import { http } from '../../config/axios'

export default function getNotaFiscalXml(id: string): Promise<Blob> {
  return http.get('/api/nota-fiscal/xml/' + id, {
    responseType: 'blob'
  })
    .then((r) => r.data)
    .then((blobFile) => {
      return blobFile
    })
    .catch((error) => {
      console.error('Erro ao getNotaFiscalXml')
      return new Blob()
    })
}
